export default {
    data() {
        return {
            statusMessage: null
        }
    },
    methods: {
        showError(message){
            this.statusMessage = {
                type: 'error',
                text: message
            }
        },
        showInfo(message){
            this.statusMessage = {
                type: 'info',
                text: message
            }
        },
        showSuccess(message){
            this.statusMessage = {
                type: 'success',
                text: message
            }
        },
        hideStatusMessages(){
            this.statusMessage = null;
        },
        showCommunicationFailed(){
            this.showError('Communication with server failed. Please try again later.');
        },
    },
}